export const dcrIcons = {
  'ui:close': `<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />`,
  'ui:add': `<path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" />`,
  'ui:open-in-new':
    '<path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>',
  'ui:class': `<path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"/>`,
  'ui:results': `<path d="M5 9.2h3V19H5V9.2zM10.6 5h2.8v14h-2.8V5zm5.6 8H19v6h-2.8v-6z" />`,
  'ui:edit': `<path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>`,
  'ui:password': `<path d="M2,17h20v2H2V17z M3.15,12.95L4,11.47l0.85,1.48l1.3-0.75L5.3,10.72H7v-1.5H5.3l0.85-1.47L4.85,7L4,8.47L3.15,7l-1.3,0.75 L2.7,9.22H1v1.5h1.7L1.85,12.2L3.15,12.95z M9.85,12.2l1.3,0.75L12,11.47l0.85,1.48l1.3-0.75l-0.85-1.48H15v-1.5h-1.7l0.85-1.47 L12.85,7L12,8.47L11.15,7l-1.3,0.75l0.85,1.47H9v1.5h1.7L9.85,12.2z M23,9.22h-1.7l0.85-1.47L20.85,7L20,8.47L19.15,7l-1.3,0.75 l0.85,1.47H17v1.5h1.7l-0.85,1.48l1.3,0.75L20,11.47l0.85,1.48l1.3-0.75l-0.85-1.48H23V9.22z"/>`,
  'ui:login': `<path d="M11,7L9.6,8.4l2.6,2.6H2v2h10.2l-2.6,2.6L11,17l5-5L11,7z M20,19h-8v2h8c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2h-8v2h8V19z"/>`,

  'ui:leerid': `
    <g id="icons">
      <g>
        <rect x="0" y="0" style="fill: #FFFFFF;" width="24" height="24"/>
        <g>
          <polygon style="fill: #15465B;" points="15.6,0 0,0 0,24 24,24 			"/>
        </g>
        <path style="fill: #FFFFFF;" d="M10,2.3c0.1,0.1,0.2,0.5,0.2,0.9c0,0.3,0,0.6-0.1,0.8C9.6,4.1,9,4.2,8.3,4.3v15.1h7c0.1-0.7,0.2-1.4,0.3-1.9
          c0.1-0.1,0.5-0.1,0.8-0.1c0.4,0,0.8,0.1,0.9,0.2c0,0.1,0.1,1,0.1,1.8v2.1H6.5c-0.8,0-1.8-0.1-1.9-0.1c-0.1-0.1-0.2-0.5-0.2-0.9
          c0-0.3,0-0.6,0.1-0.8c0.4-0.1,0.9-0.2,1.5-0.3V4.2C5.5,4.1,5,4,4.6,3.9C4.5,3.8,4.5,3.5,4.5,3.2c0-0.4,0.1-0.8,0.2-0.9
          c0.1-0.1,1-0.1,1.9-0.1h1.7C9,2.2,9.9,2.2,10,2.3z"/>
      </g>
    </g>
  `,
  'ui:kwetons': `
    <defs>
      <style>
        .svg-kweton-side-bg {
          fill: #f39200;
        }
        .svg-kweton-shadow {
          fill: #ad6600;
        }
        .svg-kweton-side-1 {
          fill: #f7b55b;
        }
        .svg-kweton-side-2 {
          fill: #f7b35b;
        }
        .svg-kweton-side-3 {
          fill: #f6af59;
        }
        .svg-kweton-side-4 {
          fill: #f6ae54;
        }
        .svg-kweton-side-5 {
          fill: #f5aa54;
        }
        .svg-kweton-side-6 {
          fill: #f5a650;
        }
        .svg-kweton-side-7 {
          fill: #f4a34e;
        }
        .svg-kweton-side-8 {
          fill: #f49f4b;
        }
        .svg-kweton-side-9 {
          fill: #f39b48;
        }
        .svg-kweton-side-10 {
          fill: #f39847;
        }
        .svg-kweton-side-11 {
          fill: #f39445;
        }
        .svg-kweton-side-12 {
          fill: #f49243;
        }

        .svg-kweton-top-outer {
          fill: #fbc46c;
        }
        .svg-kweton-top-inner {
          fill: #fab74c;
        }

        .svg-kweton-k {
          fill: #fbdd7b;
        }
      </style>
    </defs>
    <g id="svg-kweton-side">
      <path
        class="svg-kweton-side-bg"
        d="M21,15.1l-1.36,2.7c-2,4-7.37,5.28-12,2.88S1,13.12,3,9.13l1.4-2.78"
      />
      <path
        class="svg-kweton-shadow"
        d="M11.06,21.9a10.64,10.64,0,0,1-3.48-1.12A10.49,10.49,0,0,1,2.65,15.5,7.84,7.84,0,0,1,2.78,9l1.4-2.78.35.18L3.13,9.14A7.42,7.42,0,0,0,3,15.35a10.09,10.09,0,0,0,4.75,5.08c4.5,2.34,9.76,1.08,11.72-2.81l1.36-2.69.34.18L19.83,17.8C18.27,20.9,14.73,22.42,11.06,21.9Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M2.67,13.38c-.1-.05-.15-.15-.11-.21l.4-.8c0-.07.14-.08.23,0s.15.14.11.21l-.4.8A.17.17,0,0,1,2.67,13.38Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M3.3,15.2c-.1,0-.15-.15-.11-.22l.46-.91c0-.07.14-.08.23,0s.15.14.12.21l-.46.91A.18.18,0,0,1,3.3,15.2Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M4.29,16.76a.18.18,0,0,1-.11-.21l.51-1c0-.07.14-.08.23,0s.15.14.11.21l-.5,1C4.5,16.8,4.39,16.81,4.29,16.76Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M5.44,18.1c-.1-.05-.15-.15-.11-.22l.5-1c0-.07.14-.08.24,0a.18.18,0,0,1,.11.21l-.51,1A.16.16,0,0,1,5.44,18.1Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M6.82,19.29c-.1-.05-.15-.14-.11-.21l.5-1c0-.07.14-.08.23,0s.15.14.12.21l-.51,1C7,19.33,6.91,19.34,6.82,19.29Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M8.59,20.23A.18.18,0,0,1,8.48,20L9,19c0-.07.14-.08.24,0a.18.18,0,0,1,.11.21l-.5,1C8.79,20.27,8.69,20.28,8.59,20.23Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M10.2,20.77a.19.19,0,0,1-.11-.22l.51-1a.16.16,0,0,1,.23,0c.1.05.15.15.11.22l-.5,1A.18.18,0,0,1,10.2,20.77Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M12.19,21a.18.18,0,0,1-.11-.21l.51-1c0-.07.14-.08.23,0s.15.14.11.21l-.5,1C12.39,21.05,12.29,21.06,12.19,21Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M14.12,20.93c-.1-.05-.15-.14-.11-.21l.46-.91c0-.07.13-.09.23,0s.15.15.11.22l-.46.91C14.32,21,14.21,21,14.12,20.93Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M16.16,20.35c-.1-.05-.15-.14-.11-.21l.4-.8c0-.07.14-.08.23,0s.15.14.12.21l-.41.8A.17.17,0,0,1,16.16,20.35Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M2.65,11.42c-.09-.05-.14-.15-.11-.21l.25-.48a.16.16,0,0,1,.23,0c.1.05.15.15.11.21l-.24.49C2.86,11.45,2.75,11.47,2.65,11.42Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M17.75,19.25c-.1-.05-.15-.14-.11-.21l.24-.48c0-.07.14-.08.23,0s.15.14.11.21l-.24.48C18,19.29,17.84,19.3,17.75,19.25Z"
      />
      <path
        class="svg-kweton-side-1"
        d="M2.87,11.41a.18.18,0,0,1-.11-.21L3,10.72a.18.18,0,0,1,.24,0,.18.18,0,0,1,.11.22l-.24.48C3.07,11.45,3,11.46,2.87,11.41Z"
      />
      <path
        class="svg-kweton-side-2"
        d="M2.88,13.37a.18.18,0,0,1-.11-.21l.4-.8c0-.07.14-.08.24,0s.15.14.11.21l-.4.8C3.09,13.41,3,13.42,2.88,13.37Z"
      />
      <path
        class="svg-kweton-side-3"
        d="M3.52,15.19c-.1,0-.15-.15-.11-.21l.46-.92a.17.17,0,0,1,.23,0c.1.05.15.14.11.21l-.46.92A.17.17,0,0,1,3.52,15.19Z"
      />
      <path
        class="svg-kweton-side-4"
        d="M4.51,16.76a.19.19,0,0,1-.11-.22l.5-1c0-.07.14-.08.24,0s.15.14.11.21l-.5,1C4.71,16.79,4.61,16.8,4.51,16.76Z"
      />
      <path
        class="svg-kweton-side-5"
        d="M5.66,18.09c-.1-.05-.15-.15-.11-.22l.5-1a.16.16,0,0,1,.23,0c.1.05.15.15.12.21l-.51,1A.16.16,0,0,1,5.66,18.09Z"
      />
      <path
        class="svg-kweton-side-6"
        d="M7,19.29a.19.19,0,0,1-.11-.22l.51-1c0-.07.14-.08.23,0s.15.14.11.21l-.5,1C7.24,19.32,7.13,19.33,7,19.29Z"
      />
      <path
        class="svg-kweton-side-7"
        d="M8.81,20.22c-.1,0-.15-.14-.11-.21l.5-1c0-.07.14-.08.24,0a.18.18,0,0,1,.11.21l-.5,1C9,20.26,8.91,20.27,8.81,20.22Z"
      />
      <path
        class="svg-kweton-side-8"
        d="M10.42,20.76a.18.18,0,0,1-.11-.21l.5-1a.18.18,0,0,1,.24,0,.19.19,0,0,1,.11.22l-.5,1A.19.19,0,0,1,10.42,20.76Z"
      />
      <path
        class="svg-kweton-side-9"
        d="M12.41,21a.19.19,0,0,1-.11-.22l.5-1a.19.19,0,0,1,.24,0,.18.18,0,0,1,.11.21l-.5,1A.18.18,0,0,1,12.41,21Z"
      />
      <path
        class="svg-kweton-side-10"
        d="M14.33,20.93a.19.19,0,0,1-.11-.22l.46-.91c0-.07.14-.08.24,0A.19.19,0,0,1,15,20l-.46.91C14.54,21,14.43,21,14.33,20.93Z"
      />
      <path
        class="svg-kweton-side-11"
        d="M16.38,20.34c-.1-.05-.15-.14-.11-.21l.4-.8c0-.07.14-.08.23,0s.15.14.11.21l-.4.8C16.58,20.38,16.47,20.39,16.38,20.34Z"
      />

      <path
        class="svg-kweton-side-12"
        d="M18,19.25a.19.19,0,0,1-.12-.22l.25-.48c0-.07.14-.08.23,0s.15.14.11.21l-.24.48A.16.16,0,0,1,18,19.25Z"
      />
    </g>
    <g id="svg-kweton-top">
      <path
        class="svg-kweton-top-outer"
        d="M21.05,14.94c-2,4-7.37,5.28-12,2.88S2.35,10.26,4.35,6.28,11.72,1,16.34,3.4,23.06,11,21.05,14.94Z"
      />
      <path
        class="svg-kweton-shadow"
        d="M12.48,19.13A11,11,0,0,1,9,18a10.51,10.51,0,0,1-4.93-5.27,7.8,7.8,0,0,1,.13-6.54c2.05-4.08,7.54-5.41,12.24-3S23.27,11,21.22,15A7.6,7.6,0,0,1,16.08,19,9.68,9.68,0,0,1,12.48,19.13Zm.4-16.64C9.38,2,6,3.43,4.53,6.37a7.36,7.36,0,0,0-.12,6.2,10.09,10.09,0,0,0,4.75,5.08,9.85,9.85,0,0,0,6.83.93,7.2,7.2,0,0,0,4.89-3.73c1.95-3.87-.13-8.93-4.63-11.27A10.54,10.54,0,0,0,12.88,2.49Z"
      />
      <ellipse
        class="svg-kweton-top-inner"
        cx="12.69"
        cy="10.39"
        rx="6.11"
        ry="7.33"
        transform="translate(-2.55 16.44) rotate(-60.95)"
      />
      <path
        class="svg-kweton-shadow"
        d="M19.62,13.54a6.21,6.21,0,0,0-.12-5A8.5,8.5,0,0,0,15.73,4.6a8.26,8.26,0,0,0-5.32-.81,6,6,0,0,0-4,2.77A4.23,4.23,0,0,0,6.11,7c-1.56,3.11.16,7.19,3.84,9.1s8,.94,9.51-2.17Zm-9.49,2.19c-3.36-1.75-5-5.37-3.81-8.24,0-.11.09-.22.15-.33a5.25,5.25,0,0,1,4-2.59,8,8,0,0,1,4.81.88A8.2,8.2,0,0,1,18.82,8.9a5.42,5.42,0,0,1,.29,4.82c-.06.13-.14.26-.21.38C17.28,16.71,13.46,17.46,10.13,15.73Z"
      />

      <g id="svg-kweton-k">
        <polygon
          class="svg-kweton-k"
          points="12.07 10.85 13 13.79 16.11 14.27 14.55 11 14.38 10.64 17.76 9.33 16.24 7.52 13.45 8.72 13.38 8.76 14.58 6.78 12.2 5.54 8.38 11.39 10.83 12.8 12.07 10.85"
        />
        <polygon
          class="svg-kweton-shadow"
          points="14.31 7.31 14.58 6.78 13.38 8.76 13.45 8.72 14.31 7.31"
        />
        <polygon
          class="svg-kweton-shadow"
          points="14.38 10.64 14.55 11 17.49 9.87 17.76 9.33 14.38 10.64"
        />
        <polygon
          class="svg-kweton-shadow"
          points="12.07 10.85 10.83 12.8 8.38 11.39 8.2 11.75 10.65 13.16 11.81 11.38 12.73 14.32 15.84 14.8 16.11 14.27 13 13.79 12.07 10.85"
        />
      </g>
    </g>
  `,
};
